export default __webpack_public_path__ + "static/media/womendress.8d3d15c2.jpg";